import { ReactNode } from 'react';
import { AuthProvider as BaseAuthProvider } from '@/lib/auth/provider';

interface AuthProviderProps {
  children: ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
  return <BaseAuthProvider>{children}</BaseAuthProvider>;
}